import { render } from "./TheFaqListItem.vue?vue&type=template&id=28e73409&scoped=true&ts=true&lang=html"
import script from "./TheFaqListItem.vue?vue&type=script&lang=ts"
export * from "./TheFaqListItem.vue?vue&type=script&lang=ts"

import "./TheFaqListItem.vue?vue&type=style&index=0&id=28e73409&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e73409"]])

export default __exports__